@if(visit) {

  <div class="pass-page">

    <div class="pass-header">
      <span class="pass-subtitle">Pase de acceso</span>
      <h1 class="pass-brand">CradleResident</h1>
    </div>

    <div class="pass-body">

      <div class="pass-qr-frame">
        <qrcode
          #parent
          [qrdata]="visit.token"
          [elementType]="elementType"
          [width]="getScreenWidth() > 484 ? 380 : getScreenWidth() - 104"
          (qrCodeURL)="onChangeURL($event)"
          [imageSrc]="'./assets/media/logo.png'"
          [imageHeight]="40"
          [imageWidth]="40"
          [errorCorrectionLevel]="'M'">
        </qrcode>
      </div>

      @if(visit.shortCode != "") {
        <div class="pass-shortcode-wrapper">
          <span class="pass-shortcode-label">Código de acceso</span>
          <span class="pass-shortcode">{{ visit.shortCode }}</span>
        </div>
      }

    </div>

    <div class="pass-footer">
      <button
        class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
        type="button"
        (click)="saveAsImage(parent)"
        download="CradleResident-QR-Code">
        <i class="material-icons" style="font-size:1.1rem;">download</i>
        Descargar código QR
      </button>
    </div>

  </div>

}
